import React, { FunctionComponent, useMemo, useCallback } from 'react';
import { Icon, Colors, Spinner } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';

import './WorkspaceItem.scss';
import { IWorkspace } from '../../models';

type OnSelectCallback = (workspace: IWorkspace) => void;

type WorkspaceItemProps = {
  workspace: IWorkspace;
  workspaces: IWorkspace[];
  loading: boolean;
  onSelect?: OnSelectCallback;
};

export const WorkspaceItem: FunctionComponent<WorkspaceItemProps> = ({
  workspace, workspaces, loading, onSelect
}: WorkspaceItemProps) => {

  const nameToDisplay = useMemo(() => {
    // Rule: "show Organization name. Only if there are two workspaces under the same
    // organization show Organisation Name (workspace name)"

    const workspacesInSameOrganization = workspaces.filter(
      ws => ws.uid !== workspace.uid && ws.organization.uid === workspace.organization.uid
    );
    return workspacesInSameOrganization.length > 0 ?
      `${workspace.organization.name} (${workspace.name})`:
      workspace.organization.name || workspace.name;
  }, [ workspace, workspaces ]);

  const membersCount = useMemo(() => {
    return workspace.users?.length;
  }, [ workspace ]);

  const handleSelect = useCallback(() => {
    onSelect && onSelect(workspace);
  }, []);

  return (
    <div
      className="workspace__item"
      onClick={handleSelect}
    >
      <div className="workspace__item__name">
        <span className="workspace__item__name__label bp4-text-overflow-ellipsis">{nameToDisplay}</span>
        <span className="workspace__item__name__members">{membersCount} member{membersCount > 1 ? 's' : ''}</span>
      </div>
      <div className="workspace__item__icon">
        { loading ? (
          <Spinner size={20} />
        ) : (
          <Icon
            icon={IconNames.CIRCLE_ARROW_RIGHT}
            color={Colors.GRAY3}
            iconSize={24}
          />
        ) }
      </div>
    </div>
  );
};
